// This project has no tsconfig.json, so this reference is needed to pull in
// react-app-env.d.ts's ambient declarations (react-scripts types, *.css
// wildcard module) — an unimported .d.ts otherwise isn't part of this file's
// inferred TS project.
/// <reference path="../../../../../react-app-env.d.ts" />
import React from 'react';
import { useRestaurant } from '../../contexts/RestaurantContext.tsx';
import { ChevronDown, ChevronUp } from 'lucide-react';
import '../../styles/floor-texture-selector.css';

interface FloorTextureSelectorProps {
  isCollapsed?: boolean;
  onToggle?: () => void;
}

const FloorTextureSelector: React.FC<FloorTextureSelectorProps> = ({ isCollapsed = false, onToggle }) => {
  const { floors, currentFloor, updateFloor } = useRestaurant();
  const currentTexture = floors.find(f => f.id === currentFloor)?.texture || 'wood';

  const floorTextures = [
    { id: 'wood', name: 'Piso de Madeira' },
    { id: 'stone', name: 'Piso de Pedra' },
    { id: 'marble', name: 'Mármore' },
    { id: 'carpet', name: 'Carpete' }
  ];

  const handleTextureChange = (textureId: string) => {
    updateFloor(currentFloor, { texture: textureId });
  };

  return (
    <div className={`floor-texture-selector ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="selector-header" onClick={onToggle}>
        <h3>Textura do Piso</h3>
        <button className="toggle-btn">
          {isCollapsed ? <ChevronDown size={18} /> : <ChevronUp size={18} />}
        </button>
      </div>
      {!isCollapsed && (
      <div className="texture-options">
        {floorTextures.map(texture => (
          <div
            key={texture.id}
            className={`texture-option ${currentTexture === texture.id ? 'selected' : ''}`}
            onClick={() => handleTextureChange(texture.id)}
          >
            <div 
              className="texture-preview"
              style={{ backgroundImage: `url(/textures/${texture.id}.jpg)` }}
            ></div>
            <span>{texture.name}</span>
          </div>
        ))}
      </div>
      )}
    </div>
  );
};

export default FloorTextureSelector;
